// src/components/RoleProtectedRoute.js — session-based role guard
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { fetchMe } from '../lib/api';

const normalizeUser = (me) => (me && typeof me === 'object' && 'user' in me ? me.user : me);

const RoleProtectedRoute = ({ children, allowedRoles = [] }) => {
  const [state, setState] = useState({ loading: true, authed: false });

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const me = await fetchMe();
        if (!mounted) return;

        const user = normalizeUser(me);        if (user) sessionStorage.setItem('user', JSON.stringify(user));

        const ok = !!user && (allowedRoles.length === 0 || allowedRoles.includes(user.role));
        setState({ loading: false, authed: ok });
      } catch {
        if (!mounted) return;
        setState({ loading: false, authed: false });
      }
    })();
    return () => { mounted = false; };
  }, [allowedRoles.join(',')]);

  if (state.loading) return <div style={{ padding: 16 }}>Checking access…</div>;
  if (!state.authed) return <Navigate to="/" replace />;
  return children;
};

export default RoleProtectedRoute;
